import { ValidationResult } from '../../../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../../../utils/translator.helper';
import { AntimalwareOnDemandScanTarget } from '@nirvana/shared/dtos/types/policies/common';

// validate duplicates
export function validateDuplicates(
  item: AntimalwareOnDemandScanTarget,
  itemsInGrid: AntimalwareOnDemandScanTarget[]
): ValidationResult {
  const hasDuplicates = itemsInGrid.some((itemInGrid: AntimalwareOnDemandScanTarget) => itemInGrid.path === item.path);

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
